import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as l } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = l((a, e) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: e,
    ...a,
    image: (r) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...r,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3540",
              width: 16,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M.75 16c-.41 0-.75-.34-.75-.75V.75C0 .34.34 0 .75 0h14.5c.3 0 .58.18.69.46s.05.6-.16.82l-4.29 4.29 4.29 4.29a.751.751 0 0 1-.53 1.28H3.7c-.41 0-.75-.34-.75-.75s.34-.74.75-.74h9.74L9.9 6.1c-.3-.29-.3-.76 0-1.06l3.54-3.54H1.5v13.75c0 .41-.34.75-.75.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3540)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyFlagIcon";
export {
  t as AgencyFlagIcon,
  t as default
};
//# sourceMappingURL=index.js.map
